import React from "react";
import { ResponsiveHoneycomb } from "react-honeycomb-v2";
import Hexagon from "./Hexagon";
import Tile from "../../types/tile";
import { Box, useMediaQuery } from "@mui/material";
import theme from "../../theme";

interface Props {
  tiles: Tile[];
  width?: number;
  size?: number;
}

const HoneycombGrid: React.FC<Props> = (props) => {
  const { tiles, width, size } = props;

  const xl = useMediaQuery(theme.breakpoints.up("xl"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const sm = useMediaQuery(theme.breakpoints.up("sm"));
  const xs = useMediaQuery(theme.breakpoints.up("xs"));

  const hexagonSize =
    size ||
    (() => {
      switch (true) {
        case xl:
          return 250;
        case lg:
          return 240;
        case md:
          return 200;
        case sm:
          return 190;
        case xs:
          return 130;
        default:
          return 100;
      }
    })();

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
      }}
    >
      <ResponsiveHoneycomb
        defaultWidth={width || 1024}
        size={hexagonSize}
        items={tiles}
        renderItem={(tile: Tile) => <Hexagon key={tile?.id} tile={tile} />}
      />
    </Box>
  );
};

export default HoneycombGrid;
